import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Plus, Minus } from "lucide-react";

export default function FaqSection({ faqs = [], testId = "faq-section" }) {
  const [open, setOpen] = useState(0);
  if (!faqs.length) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="py-20 md:py-28 border-b border-white/10" data-testid={testId}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="eyebrow">FAQ</div>
        <h2 className="font-display text-3xl md:text-5xl uppercase mt-3 tracking-tighter">
          Questions, answered.
        </h2>
        <div className="mt-10 border-t border-white/10">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-white/10" data-testid={`faq-item-${i}`}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-display text-base md:text-lg uppercase tracking-tight leading-tight">
                    {f.q}
                  </span>
                  {isOpen ? (
                    <Minus size={18} className="text-[#e63946] flex-shrink-0" />
                  ) : (
                    <Plus size={18} className="text-zinc-500 flex-shrink-0" />
                  )}
                </button>
                {isOpen && (
                  <p className="text-sm text-zinc-400 leading-relaxed pb-6 -mt-1 max-w-2xl">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
